import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import {
  InputGroupAddon,
  InputGroupButton,
} from "@/components/ui/input-group";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { MAX_VALID_DATE_YEAR } from "@/constants/dates";

/** Last selectable date in the calendar. */
const MAX_SELECTABLE_DATE = new Date(MAX_VALID_DATE_YEAR, 11, 31);

interface DatePickerPopoverProps {
  open: boolean;
  onOpenChange: (_open: boolean) => void;
  pickDateLabel: string;
  todayLabel: string;
  disabled?: boolean;
  selected?: Date;
  month?: Date;
  onMonthChange: (_month: Date) => void;
  onSelect: (_date: Date | undefined) => void;
  isDateDisabled: (_date: Date) => boolean;
  allowOlderDates?: boolean;
  onToday: () => void;
}

export function DatePickerPopover({
  open,
  onOpenChange,
  pickDateLabel,
  todayLabel,
  disabled,
  selected,
  month,
  onMonthChange,
  onSelect,
  isDateDisabled,
  allowOlderDates,
  onToday,
}: DatePickerPopoverProps) {
  return (
    <InputGroupAddon align="inline-end">
      <Popover open={open} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>
          <InputGroupButton
            type="button"
            variant="ghost"
            size="icon-xs"
            aria-label={pickDateLabel}
            disabled={disabled}
          >
            <CalendarIcon />
            <span className="sr-only">{pickDateLabel}</span>
          </InputGroupButton>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto overflow-hidden p-0"
          align="end"
          alignOffset={-8}
          sideOffset={10}
        >
          <Calendar
            mode="single"
            selected={selected}
            month={month}
            onMonthChange={onMonthChange}
            onSelect={onSelect}
            disabled={isDateDisabled}
            startMonth={allowOlderDates ? undefined : new Date()}
            endMonth={MAX_SELECTABLE_DATE}
          />
          <div className="border-t p-2">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="w-full"
              onClick={onToday}
            >
              {todayLabel}
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </InputGroupAddon>
  );
}
